export const ArrowSvg = () => (
  <svg viewBox="0 0 20 20" fill="none">
    <path
      stroke="#fff"
      d="M1.646 10.316H19m0 0c-1.57.766-2.305 1.518-3.39 3.332M19 10.316C17.59 9.654 16.847 8.968 15.61 7"
    />
  </svg>
)
